
import React from 'react';
import './SandboxBanner.css';

/**
 * Banner displayed at the top of API booking flow pages when backend is in sandbox mode
 * Shows warning that this is a test environment
 */
const SandboxBanner: React.FC = () => {
  return (
    <div className="sandbox-banner">
      <div className="sandbox-banner-content">
        <div className="sandbox-banner-icon">
          ⚠️
        </div>
        <div className="sandbox-banner-text">
          <strong>Sandbox Mode:</strong> You are in test mode. No real bookings will be processed.
        </div>
      </div>
    </div>
  );
};

export default SandboxBanner;
